import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { setModal, selectModal } from "../../../redux/modalSlice";
import Pagination from "../../../components/Pagination";

export default function CampaignTestRunResultModal() {
  const dispatch = useDispatch();
  const modal = useSelector(selectModal);
  const responseData = modal.options?.responseData

  const handleCancel = () => {
    dispatch(setModal({ is_active: false }));
  };

  // eslint-disable-next-line no-nested-ternary
  return modal.is_active && modal.type === 'campaign_test_run_result_modal' ? (
    // eslint-disable-next-line no-nested-ternary
    <div className="modal is-active">
      <div className="modal-background"></div>
      <div className="modal-card is-7" style={{ width: "70%" }}>
        <header className="modal-card-head py-3">
          <p className="modal-card-title is-capitalized">Test Run Query Result ({responseData?.total})</p>
          <button className="delete" aria-label="close" onClick={handleCancel}></button>
        </header>
        <section
          className="modal-card-body modal-card-body mb-0 pt-1 pb-1"
          style={{ minHeight: "400px" }}
        >
          {responseData?.data ? (
            <div className="columns my-2">
              <div
                className="lox-hooktable column is-full table-container m-0"
              >
                <table
                  className="lox-hooktable-table table is-bordered is-striped is-narrow is-hoverable is-fullwidth is-grey"
                >
                  <thead>
                    <tr className="is-selected">
                      <th className="is-selected has-text-centered">Customer ID</th>
                      <th className="is-selected has-text-centered">Customer Name</th>
                      <th className="is-selected has-text-centered">Lead</th>
                      <th className="is-selected has-text-centered">Loan</th>
                      <th className="is-selected has-text-centered">Payment ID</th>
                    </tr>
                  </thead>
                  <tbody>
                    {responseData?.data?.map((row, index) => {
                      return (
                        // eslint-disable-next-line react/no-array-index-key
                        <tr key={index}>
                          <td className="has-text-left">{row.customer_id}</td>
                          <td className="has-text-left">{row.customer_label}</td>
                          <td className="has-text-left">{row.lead_label}</td>
                          <td className="has-text-left">{row.loan_label}</td>
                          <td className="has-text-left">{row.payment_id}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
                {responseData ? <Pagination meta={responseData} paginateCallback={modal?.options?.getTestQueryResult} /> : null}
              </div>
            </div>
          ) : null}
        </section>
        <footer className="modal-card-foot is-justify-content-end py-1">
          <div className="portfolio-select-header"></div>
          <div className="lox-form__buttons-wrapper has-text-right">
          </div>
        </footer>
      </div>
    </div>
  ) : null;
}
